import api from '@edu-fe/api'

export default {
  name: 'schedule',
  getData: api.create('/course/schedule')
}
